export default [
    {
        name: '[[[Strona główna]]]',
        short: '[[[Start]]]',
        route: 'dashboard',
        icon: 'fa-light fa-house-chimney',
        children: [
            {
                name: '[[[Profil użytkownika]]]',
                route: 'core-account-profile',
                icon: 'far fa-fw fa-user-circle'
            },
            {
                name: '[[[Zmiana hasła]]]',
                route: 'core-account-password',
                icon: 'far fa-fw fa-toggle-on'
            },
            {
                name: '[[[Centrum powiadomień]]]',
                route: 'core-account-notifications',
                icon: 'far fa-fw fa-envelope-open',
                query: {status: 'unreaded'},
                event: 'notifications::reload-list'
            },
            {
                name: '[[[Bezpieczeństwo]]]',
                route: 'core-account-security',
                icon: 'far fa-fw fa-phone-laptop'
            },
            {
                name: '[[[Tokeny dostępu]]]',
                route: 'core-pats',
                icon: 'far fa-fw fa-key'
            },
            {
                name: '[[[Dashboardy]]]',
                route: 'core-dashboards',
                icon: 'far fa-display-chart-up',
                auth: { all: ['DashboardPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie dashboardu]]]',
                        route: 'core-dashboards-add',
                        auth: { all: ['DashboardPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja dashboardu]]]',
                        route: 'core-dashboards-edit',
                        auth: { all: ['DashboardPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja aranżacji dashboardu]]]',
                        route: 'core-dashboards-arrangement',
                        auth: { all: ['DashboardPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            }
        ]
    },
    {
        name: '[[[Usługi]]]',
        short: '[[[Usługi]]]',
        icon: 'fa-light fa-server',
        namespace: 'Ideo.Core.Common.Application.Permissions.Saas',
        children: [
            {
                name: '[[[Klienci]]]',
                route: 'saas-tenants',
                icon: 'far fa-fw fa-users-class',
                auth: { all: ['TenantsPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie klienta]]]',
                        route: 'saas-tenants-add',
                        auth: { all: ['TenantsPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja klienta]]]',
                        route: 'saas-tenants-edit',
                        auth: { all: ['TenantsPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Bazy danych]]]',
                route: 'saas-databases',
                icon: 'far fa-fw fa-database',
                auth: { all: ['DatabasesPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie serwera]]]',
                        route: 'saas-databases-add',
                        auth: { all: ['DatabasesPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja serwera]]]',
                        route: 'saas-databases-edit',
                        auth: { all: ['DatabasesPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Serwery plików]]]',
                route: 'saas-storages',
                icon: 'far fa-fw fa-hdd',
                auth: { all: ['StoragesPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie serwera]]]',
                        route: 'saas-storages-add',
                        auth: { all: ['StoragesPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja serwera]]]',
                        route: 'saas-storages-edit',
                        auth: { all: ['StoragesPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            }
        ]
    },
    {
        name: '[[[System]]]',
        short: '[[[System]]]',
        icon: 'fal fa-display',
        namespace: 'Ideo.Core.Common.Application.Permissions.Core',
        children: [
            {
                name: '[[[Administracja]]]',
                icon: 'far fa-fw fa-folder-user',
                children: [
                    {
                        name: '[[[Użytkownicy]]]',
                        route: 'core-users',
                        icon: 'far fa-fw fa-user',
                        auth: { all: ['UsersPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie użytkownika]]]',
                                route: 'core-users-add',
                                auth: { all: ['UsersPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja użytkownika]]]',
                                route: 'core-users-edit',
                                auth: { all: ['UsersPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Role i uprawnienia]]]',
                        route: 'core-roles',
                        icon: 'far fa-fw fa-user-shield',
                        auth: { all: ['RolesPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie roli]]]',
                                route: 'core-roles-add',
                                auth: { all: ['RolesPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja roli]]]',
                                route: 'core-roles-edit',
                                auth: { all: ['RolesPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Organizacja]]]',
                        route: 'core-units',
                        icon: 'far fa-fw fa-sitemap',
                        auth: { all: ['OrganizationPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie działu]]]',
                                route: 'core-units-add',
                                auth: { all: ['OrganizationPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja działu]]]',
                                route: 'core-units-edit',
                                auth: { all: ['OrganizationPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Zespoły]]]',
                        route: 'core-teams',
                        icon: 'far fa-fw fa-users',
                        auth: { all: ['TeamsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie zespołu]]]',
                                route: 'core-teams-add',
                                auth: { all: ['TeamsPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja zespołu]]]',
                                route: 'core-teams-edit',
                                auth: { all: ['TeamsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Zastępstwa]]]',
                        route: 'core-substitutions',
                        icon: 'far fa-fw fa-user-group',
                        auth: { all: ['SubstitutionsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie zastępstwa]]]',
                                route: 'core-substitutions-add',
                                auth: { all: ['SubstitutionsPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja zastępstwa]]]',
                                route: 'core-substitutions-edit',
                                auth: { all: ['SubstitutionsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    }
                ]
            },
            {
                name: '[[[Wyszukiwanie]]]',
                icon: 'far fa-fw fa-input-pipe',
                namespace: 'Ideo.Core.Common.Application.Permissions.Search',
                children: [
                    {
                        name: '[[[Lista indeksów]]]',
                        auth: { all: ['SearchPermissions@Access'], any: [] },
                        route: 'search-indices'
                    },
                    {
                        name: '[[[Słowa wykluczone]]]',
                        auth: { all: ['StopWordsPermissions@Access'], any: [] },
                        route: 'search-stopwords'
                    },
                    {
                        name: '[[[Synonimy]]]',
                        auth: { all: ['SynonymsPermissions@Access'], any: [] },
                        route: 'search-synonyms'
                    }
                ]
            },
            {
                name: '[[[Ustawienia]]]',
                icon: 'far fa-fw fa-cog',
                children: [
                    {
                        name: '[[[Konta użytkowników]]]',
                        route: 'core-accounts',
                        icon: 'far fa-fw fa-users',
                        auth: { all: ['AdminPermissions@Accounts'], any: [] }
                    },
                    {
                        name: '[[[Aktywacja kont po rejestracji]]]',
                        route: 'core-accounts-activation',
                        icon: 'far fa-fw fa-users',
                        auth: { all: ['AdminPermissions@AccountsActivation'], any: [] }
                    },
                    {
                        name: '[[[Bezpieczeństwo]]]',
                        route: 'core-security',
                        icon: 'far fa-fw fa-shield-alt',
                        auth: { all: ['AdminPermissions@Security'], any: [] }
                    },
                    {
                        name: '[[[Zaufane adresy IP]]]',
                        route: 'core-trusted-ips',
                        icon: 'far fa-fw fa-shield-alt',
                        auth: { all: ['AdminPermissions@TrustedIPs'], any: [] }
                    },
                    {
                        name: '[[[ReCaptcha]]]',
                        route: 'core-recaptcha',
                        icon: 'far fa-fw fa-shield-alt',
                        auth: { all: ['AdminPermissions@Recaptcha'], any: [] }
                    },
                    {
                        name: '[[[Poczta]]]',
                        route: 'core-mailing',
                        icon: 'fa-regular fa-envelope',
                        auth: { all: ['AdminPermissions@Mailing'], any: [] }
                    },
                    {
                        name: '[[[Formularz kontaktowy]]]',
                        route: 'md-contact-forms',
                        icon: 'far fa-fw fa-shield-alt',
                        auth: { all: ['ContactFormEntriesPermissions@EditEmails'], any: [] }
                    },
                    {
                        name: '[[[Szablony powiadomień]]]',
                        route: 'core-notifications-templates',
                        icon: 'far fa-fw fa-ballot-check',
                        auth: { all: ['NotificationsPermissions@Access'], any: [] },
                        children: [
                            {
                                name: '[[[Lista szablonów]]]',
                                route: 'core-notifications-templates',
                                auth: { all: ['NotificationsPermissions@Access'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Dodaj szablon]]]',
                                route: 'core-notifications-templates-add',
                                auth: { all: ['NotificationsPermissions@Access'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edytuj szablon]]]',
                                route: 'core-notifications-templates-edit',
                                auth: { all: ['NotificationsPermissions@Access'], any: [] },
                                visible: false,
                            }
                        ]
                    },
                    {
                        name: '[[[Centrum powiadomień]]]',
                        route: 'core-notifications-collective',
                        icon: 'far fa-fw fa-ballot-check',
                        auth: { all: ['CollectiveNotificationsPermissions@Access'], any: [] },
                        children: [
                            {
                                name: '[[[Lista powiadomień zbiorowych]]]',
                                route: 'core-notifications-collective',
                                auth: { all: ['CollectiveNotificationsPermissions@Access'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Dodaj powiadomienie zbiorowe]]]',
                                route: 'core-notifications-collective-add',
                                auth: { all: ['CollectiveNotificationsPermissions@Access'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edytuj powiadomienie zbiorowe]]]',
                                route: 'core-notifications-collective-edit',
                                auth: { all: ['CollectiveNotificationsPermissions@Access'], any: [] },
                                visible: false,
                            }
                        ]
                    },
                    {
                        name: '[[[Źródła LDAP]]]',
                        route: 'core-ldap',
                        icon: 'far fa-fw fa-shield-alt',
                        auth: { all: ['AdminPermissions@LdapConfig'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie źródła]]]',
                                route: 'core-ldap-add',
                                auth: { all: ['AdminPermissions@LdapConfig'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja źródła]]]',
                                route: 'core-ldap-edit',
                                auth: { all: ['AdminPermissions@LdapConfig'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Bramka SMS]]]',
                        route: 'core-sms',
                        icon: 'far fa-fw fa-shield-alt',
                        auth: { all: ['AdminPermissions@Sms'], any: [] }
                    },
                    {
                        name: '[[[Ustawienia Firebase]]]',
                        route: 'core-firebase',
                        icon: 'far fa-fw fa-shield-alt',
                        auth: { all: ['AdminPermissions@Firebases'], any: [] }
                    },
                    {
                        name: '[[[Paleta kolorów - Panel]]]',
                        route: 'core-colors',
                        icon: 'far fa-fw fa-palette',
                        auth: { all: ['AdminPermissions@Colors'], any: [] }
                    },
                    // {
                    //     name: '[[[Tłumaczenia]]]',
                    //     route: 'core-translations',
                    //     icon: 'far fa-fw fa-subtitles',
                    //     auth: { all: ['AdminPermissions@Translations'], any: [] }
                    // },
                    {
                        name: '[[[Paleta kolorów - Front]]]',
                        route: 'md-colors-front',
                        icon: 'far fa-fw fa-palette',
                        auth: { all: ['AdminPermissions@Colors'], any: [] },
                    },
                    {
                        name: '[[[Paleta kolorów - Aplikacja mobilna]]]',
                        route: 'md-colors-mobile',
                        icon: 'far fa-fw fa-palette',
                        auth: { all: ['AdminPermissions@Colors'], any: [] },
                    },
                    {
                        name: '[[[Strony]]]',
                        route: 'md-pages',
                        icon: 'far fa-fw fa-palette',
                        auth: { all: ['AdminPermissions@Pages'], any: [] },
                    },
                    {
                        name: '[[[Sztuczna inteligencja]]]',
                        route: 'core-ai',
                        icon: 'far fa-fw fa-shield-alt',
                        auth: { all: ['AdminPermissions@Ai'], any: [] }
                    },
                    {
                        name: '[[[Tłumaczenia]]]',
                        route: 'core-translations',
                        icon: 'far fa-fw fa-subtitles',
                        auth: { all: ['AdminPermissions@Translations'], any: [] }
                    },
                    {
                        name: '[[[Monitoring]]]',
                        route: 'core-monitoring',
                        icon: 'far fa-fw fa-shield-alt',
                        auth: { all: ['AdminPermissions@Monitoring'], any: [] }
                    },
                    {
                        name: '[[[Logi]]]',
                        route: 'core-logs',
                        icon: 'far fa-fw fa-shield-alt',
                        auth: { all: ['AdminPermissions@Logs'], any: [] },
                        children: [
                            {
                                name: '[[[Edycja logów]]]',
                                route: 'core-logs-edit',
                                auth: { all: ['AdminPermissions@Logs'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Sztuczna inteligencja]]]',
                        route: 'core-ai-settings',
                        auth: { all: ['AdminPermissions@Ai'], any: [] }
                    }
                ]
            },
            {
                name: '[[[Monitoring]]]',
                icon: 'far fa-fw fa-analytics',
                children: [
                    {
                        name: '[[[Historia logowania]]]',
                        route: 'core-authlog',
                        icon: 'far fa-fw fa-file-import',
                        auth: { all: ['AdminPermissions@Authlog'], any: [] }
                    },
                    {
                        name: '[[[Rejestr zmian]]]',
                        route: 'core-changelog',
                        icon: 'far fa-fw fa-file-signature',
                        auth: { all: ['AdminPermissions@Changelog'], any: [] },
                        children: [
                            {
                                name: '[[[Szczegóły zdarzenia]]]',
                                route: 'core-changelog-diff',
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Harmonogram zadań]]]',
                        route: 'core-scheduler',
                        icon: 'far fa-fw fa-clock',
                        auth: { all: ['SchedulerPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Historia zadania]]]',
                                route: 'core-scheduler-history',
                                visible: false
                            },
                            {
                                name: '[[[Szczegóły zadania]]]',
                                route: 'core-scheduler-details',
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Monitor kolejek]]]',
                        route: 'core-queues',
                        icon: 'far fa-fw fa-clock',
                        auth: { all: ['MessagePermissions@View'], any: [] },
                        children: [
                            {
                                name: "[[[Szczegóły zadania]]]",
                                route: 'core-queues-details',
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Lista sitemap]]]',
                        route: 'core-sitemap-monitoring',
                        icon: 'fa-regular fa-sitemap',
                        auth: { all: ['AdminPermissions@Sitemap'], any: [] }
                    }
                ]
            },
        ]
    },
    {
        name: '[[[Design Studio]]] (β)',
        short: '[[[Studio]]]',
        icon: 'fa-light fa-circle-nodes', // fa-gear
        namespace: 'Ideo.Core.Common.Application.Permissions.Studio',
        children: [
            {
                name: '[[[Formularze]]]',
                icon: 'far fa-fw fa-table-layout',
                auth: { all: ['FormsPermissions@Access'], any: [] },
                route: 'studio-forms',
                children: [
                    {
                        name: '[[[Edycja formularza]]]',
                        route: 'studio-forms-edit',
                        auth: { all: [], any: ['FormsPermissions@Edit', 'FormsPermissions@EditAll'] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Komponenty]]]',
                icon: 'far fa-fw fa-grid-round-2-plus',
                auth: { all: ['ComponentsPermissions@Access'], any: [] },
                route: 'studio-components',
                children: [
                    {
                        name: '[[[Dodanie komponentu]]]',
                        route: 'studio-components-add',
                        auth: { all: ['ComponentsPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja komponentu]]]',
                        route: 'studio-components-edit',
                        auth: { all: ['ComponentsPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Źródła danych]]]',
                route: 'studio-datasources',
                icon: 'far fa-fw fa-database',
                auth: { all: ['DataSourcesPermissions@Access'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie źródła danych]]]',
                        route: 'studio-datasources-add',
                        auth: { all: ['DataSourcesPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja źródła danych]]]',
                        route: 'studio-datasources-edit',
                        auth: { all: ['DataSourcesPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Moduły]]]',
                icon: 'far fa-fw fa-layer-group',
                auth: { all: ['ModulesPermissions@Access'], any: [] },
                route: 'studio-modules',
                children: [
                    {
                        name: '[[[Dodanie modułu]]]',
                        route: 'studio-modules-add',
                        auth: { all: ['ModulesPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja modułu]]]',
                        route: 'studio-modules-edit',
                        auth: { all: ['ModulesPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[RESTful API]]]',
                icon: 'far fa-fw fa-brackets-curly',
                auth: { all: ['HeadlessPermissions@Access'], any: [] },
                route: 'studio-endpoints',
                children: [
                    {
                        name: '[[[Dodanie endpointu]]]',
                        route: 'studio-endpoints-add',
                        auth: { all: ['HeadlessPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja endpointu]]]',
                        route: 'studio-endpoints-edit',
                        auth: { all: ['HeadlessPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Webhooki]]]',
                icon: 'far fa-fw fa-webhook',
                auth: { all: ['WebhooksPermissions@Access'], any: [] },
                route: 'studio-webhooks',
                children: [
                    {
                        name: '[[[Dodanie webhooka]]]',
                        route: 'studio-webhooks-add',
                        auth: { all: ['WebhooksPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja webhooka]]]',
                        route: 'studio-webhooks-edit',
                        auth: { all: ['WebhooksPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Logi]]]',
                        route: 'studio-webhooks-logs',
                        auth: { all: ['WebhooksPermissions@Access'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Automatyzacja]]]',
                icon: 'far fa-fw fa-gears', // fa-braille
                auth: { all: ['AutomationPermissions@Access'], any: [] },
                url: '#',
                route: 'studio-automations',
                children: [
                    {
                        name: '[[[Dodanie scenariusza]]]',
                        route: 'studio-automations-add',
                        auth: { all: ['AutomationPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja scenariusza]]]',
                        route: 'studio-automations-edit',
                        auth: { all: ['AutomationPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Asystent AI]]]',
                icon: 'far fa-fw fa-microchip-ai',
                auth: { all: ['AdminPermissions@Ai'], any: [] },
                children: [
                    {
                        name: '[[[Asystenci]]]',
                        route: 'core-ai-assistants',
                        children: [
                            {
                                name: '[[[Dodanie asystenta]]]',
                                route: 'core-ai-assistants-add',
                                visible: false
                            },
                            {
                                name: '[[[Edycja asystenta]]]',
                                route: 'core-ai-assistants-edit',
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Pliki asystenta]]]',
                        route: 'core-ai-files',
                        url: '#',
                        children: [
                            {
                                name: '[[[Dodanie pliku]]]',
                                route: 'core-ai-files-add',
                                visible: false
                            },
                            {
                                name: '[[[Edycja pliku]]]',
                                route: 'core-ai-files-edit',
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Funkcje asystenta]]]',
                        route: 'core-ai-functions',
                        children: [
                            {
                                name: '[[[Dodanie funkcji]]]',
                                route: 'core-ai-functions-add',
                                visible: false
                            },
                            {
                                name: '[[[Edycja funkcji]]]',
                                route: 'core-ai-functions-edit',
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Historia zapytań do AI]]]',
                        route: 'core-ai-history',
                        children: [
                            {
                                name: '[[[Szczegóły zapytania]]]',
                                route: 'core-ai-history-details',
                                visible: false
                            }
                        ]
                    }
                ]
            }
            // {
            //     name: '[[[Dokumenty]]]',
            //     icon: 'far fa-fw fa-notebook',
            //     auth: { all: ['EntriesPermissions@Access'], any: [] },
            //     route: 'studio-entries',
            //     children: [
            //         {
            //             name: '[[[Dodanie dokumentu]]]',
            //             route: 'studio-entries-add',
            //             auth: { all: [], any: ['EntriesPermissions@Edit', 'EntriesPermissions@EditAll'] },
            //             visible: false
            //         },
            //         {
            //             name: '[[[Edycja dokumentu]]]',
            //             route: 'studio-entries-edit',
            //             auth: { all: [], any: ['EntriesPermissions@Edit', 'EntriesPermissions@EditAll'] },
            //             visible: false
            //         }
            //     ]
            // }
        ]
    },
    {
        name: '[[[Platforma lojalnościowa]]]',
        short: '[[[Platforma]]]',
        icon: 'fa-brands fa-galactic-senate',
        namespace: 'Ideo.Core.Edito.Application.Permissions.Md',
        children: [
            // {
            //     name: '[[[Kategorie]]]',
            //     icon: 'far fa-fw fa-list-check',
            //     auth: { all: ['ProgramCategoriesPermissions@View'], any: [] },
            //     route: 'md-program-categories',
            //     children: [
            //         {
            //             name: '[[[Dodanie kategorii]]]',
            //             route: 'md-program-categories-add',
            //             auth: { all: [], any: ['ProgramCategoriesPermissions@Edit'] },
            //             visible: false
            //         },
            //         {
            //             name: '[[[Edycja kategorii]]]',
            //             route: 'md-program-categories-edit',
            //             auth: { all: [], any: ['ProgramCategoriesPermissions@Edit'] },
            //             visible: false
            //         }
            //     ]
            // },
            // {
            //     name: '[[[Produkty]]]',
            //     icon: 'far fa-fw fa-solid fa-boxes-stacked',
            //     auth: { all: ['ProductsPermissions@View'], any: [] },
            //     route: 'md-products',
            //     children: [
            //         {
            //             name: '[[[Dodanie produktu]]]',
            //             route: 'md-products-add',
            //             auth: { all: [], any: ['ProductsPermissions@Edit'] },
            //             visible: false
            //         },
            //         {
            //             name: '[[[Edycja produktu]]]',
            //             route: 'md-products-edit',
            //             auth: { all: [], any: ['ProductsPermissions@Edit'] },
            //             visible: false
            //         }
            //     ]
            // },
            // {
            //     name: '[[[Promocje]]]',
            //     icon: 'far fa-fw fa-table-layout',
            //     auth: { all: ['PromotionsPermissions@View'], any: [] },
            //     route: 'md-promotions',
            //     children: [
            //         {
            //             name: '[[[Dodanie promocji]]]',
            //             route: 'md-promotions-add',
            //             auth: { all: [], any: ['PromotionsPermissions@Edit'] },
            //             visible: false
            //         },
            //         {
            //             name: '[[[Edycja promocji]]]',
            //             route: 'md-promotions-edit',
            //             auth: { all: [], any: ['PromotionsPermissions@Edit'] },
            //             visible: false
            //         }
            //     ]
            // },
            // {
            //     name: '[[[Ekspozycje zgłoszenia]]]',
            //     icon: 'far fa-fw fa-table-layout',
            //     auth: { all: ['PromotionExposuresPermissions@View'], any: [] },
            //     route: 'md-promotion-exposures',
            //     children: [
            //         {
            //             name: '[[[Szczegóły zgłoszenia ekspozycji]]]',
            //             route: 'md-promotion-exposures-edit',
            //             auth: { all: [], any: ['PromotionExposuresPermissions@Edit'] },
            //             visible: false
            //         }
            //     ]
            // },
            {
                name: '[[[Popup]]]',
                icon: 'far fa-fw fa-solid fa-message',
                namespace: 'Ideo.Core.Edito.Application.Permissions.Modules',
                auth: { all: ['PopupsPermissions@View'], any: [] },
                route: 'md-popups',
                children: [
                    {
                        name: '[[[Dodanie popupu]]]',
                        route: 'md-popups-add',
                        auth: { all: [], any: ['PopupsPermissions@Edit'] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja popupu]]]',
                        route: 'md-popups-edit',
                        auth: { all: [], any: ['PopupsPermissions@Edit'] },
                        visible: false
                    }
                ]
            },
            // {
            //     name: '[[[Kody promocyjne]]]',
            //     icon: 'far fa-fw fa-ticket',
            //     auth: { all: ['PromotionalCodesPermissions@View'], any: [] },
            //     children: [
            //         {
            //             name: '[[[Zestawy kodów]]]',
            //             route: 'md-promotional-code-sets',
            //             auth: { all: [], any: ['PromotionalCodesPermissions@View'] },
            //         },
            //         {
            //             name: '[[[Błędne próby]]]',
            //             route: 'md-promotional-code-failures',
            //             auth: { all: [], any: ['PromotionalCodesPermissions@View'] },
            //         },
            //         {
            //             name: '[[[Dodanie zestawu kodów]]]',
            //             route: 'md-promotional-code-sets-add',
            //             auth: { all: [], any: ['PromotionalCodesPermissions@Edit'] },
            //             visible: false
            //         },
            //         {
            //             name: '[[[Edycja zestawu kodów]]]',
            //             route: 'md-promotional-code-sets-edit',
            //             auth: { all: [], any: ['PromotionalCodesPermissions@Edit'] },
            //             visible: false,
            //             children: [
            //                 {
            //                     name: '[[[Lista wygenerowanych kodów]]]',
            //                     route: 'md-promotional-code-sets-generated',
            //                     auth: { all: [], any: ['PromotionalCodesPermissions@View'] },
            //                     visible: false
            //                 },
            //                 {
            //                     name: '[[[Lista wykorzystanych kodów]]]',
            //                     route: 'md-promotional-code-sets-used',
            //                     auth: { all: [], any: ['PromotionalCodesPermissions@View'] },
            //                     visible: false,
            //                     children:[
            //                         {
            //                             name: '[[[Edytuj]]]',
            //                             route: 'md-promotional-code-sets-used-edit',
            //                             auth: { all: [], any: ['PromotionalCodesPermissions@Edit'] },
            //                             visible: false
            //                         },
            //                     ],
            //                 },
            //             ]
            //         },
            //         {
            //             name: '[[[Generowanie kodów]]]',
            //             route: 'md-promotional-code-sets-generate',
            //             auth: { all: [], any: ['PromotionalCodesGenerateForm@Edit'] },
            //             visible: false
            //         },
            //     ]
            // },
            {
                name: '[[[Punkty użytkowników]]]',
                icon: 'far fa-fw fa-solid fa-coins',
                auth: { all: ['UserPointsPermissions@View'], any: [] },
                route: 'md-user-points',
                children: [
                    {
                        name: '[[[Dodanie punktu]]]',
                        route: 'md-user-points-add',
                        auth: { all: [], any: ['UserPointsPermissions@Edit'] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja punktu]]]',
                        route: 'md-user-points-edit',
                        auth: { all: [], any: ['UserPointsPermissions@Edit'] },
                        visible: false
                    }
                ]
            },
            // {
            //     name: '[[[Raporty sprzedaży]]]',
            //     icon: 'far fa-fw fa-regular fa-file',
            //     auth: { all: ['SaleReportsPermissions@View'], any: [] },
            //     route: 'md-sale-reports',
            //     children: [
            //         {
            //             name: '[[[Dodanie zgłoszenia]]]',
            //             route: 'md-sale-reports-add',
            //             auth: { all: [], any: ['SaleReportsPermissions@Edit'] },
            //             visible: false
            //         },
            //         {
            //             name: '[[[Edycja sprzedaży]]]',
            //             route: 'md-sale-reports-edit',
            //             auth: { all: [], any: ['SaleReportsPermissions@Edit'] },
            //             visible: false
            //         }
            //     ]
            // },
            {
                name: '[[[Formularz kontaktowy]]]',
                icon: 'far fa-fw fa-solid fa-message',
                auth: { all: ['ContactFormEntriesPermissions@View'], any: [] },
                route: 'contact-form-entries',
                children: [
                    {
                        name: '[[[Podglad zgłoszenia]]]',
                        route: 'contact-form-entries-edit',
                        auth: { all: [], any: ['ContactFormEntriesPermissions@Edit'] },
                        visible: false
                    }
                ]
            },
            // {
            //     name: '[[[Dystrybutorzy]]]',
            //     icon: 'far fa-fw fa-solid fa-building',
            //     auth: { all: ['DistributorsPermissions@View'], any: [] },
            //     route: 'md-distributors',
            //     children: [
            //         {
            //             name: '[[[Dodanie dystrybutora]]]',
            //             route: 'md-distributors-add',
            //             auth: { all: [], any: ['DistributorsPermissions@Edit'] },
            //             visible: false
            //         },
            //         {
            //             name: '[[[Edycja dystrybutora]]]',
            //             route: 'md-distributors-edit',
            //             auth: { all: [], any: ['DistributorsPermissions@Edit'] },
            //             visible: false
            //         }
            //     ]
            // },
            // {
            //     name: '[[[Urzędy skarbowe]]]',
            //     icon: 'far fa-fw fa-solid fa-layer-group',
            //     auth: { all: ['TaxOfficesPermissions@View'], any: [] },
            //     route: 'md-tax-offices',
            //     children: [
            //         {
            //             name: '[[[Dodanie urzędu skarbowego]]]',
            //             route: 'md-tax-offices-add',
            //             auth: { all: [], any: ['TaxOfficesPermissions@Edit'] },
            //             visible: false
            //         },
            //         {
            //             name: '[[[Edycja urzędu skarbowego]]]',
            //             route: 'md-tax-offices-edit',
            //             auth: { all: [], any: ['TaxOfficesPermissions@Edit'] },
            //             visible: false
            //         }
            //     ]
            // },
            // {
            //     name: '[[[Kody pocztowe]]]',
            //     icon: 'far fa-fw fa-solid fa-envelope',
            //     auth: { all: ['PostalCodesPermissions@View'], any: [] },
            //     route: 'md-postal-codes',
            //     children: [
            //         {
            //             name: '[[[Dodanie kodu pocztowego]]]',
            //             route: 'md-postal-codes-add',
            //             auth: { all: [], any: ['PostalCodesPermissions@Edit'] },
            //             visible: false
            //         },
            //         {
            //             name: '[[[Edycja kodu pocztowego]]]',
            //             route: 'md-postal-codes-edit',
            //             auth: { all: [], any: ['PostalCodesPermissions@Edit'] },
            //             visible: false
            //         }
            //     ]
            // },
            {
                name: '[[[Firmy]]]',
                icon: 'far fa-fw fa-solid fa-building',
                auth: { all: ['CompaniesPermissions@View'], any: [] },
                route: 'md-companies',
                children: [
                    {
                        name: '[[[Dodanie firmy]]]',
                        route: 'md-companies-add',
                        auth: { all: [], any: ['CompaniesPermissions@Edit'] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja firmy]]]',
                        route: 'md-companies-edit',
                        auth: { all: [], any: ['CompaniesPermissions@Edit'] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Importy danych]]]',
                icon: 'far fa-fw fa-solid fa-upload',
                auth: { all: ['DataImportsPermissions@View'], any: [] },
                route: 'md-data-imports',
                children: [
                    {
                        name: '[[[Dodanie importu]]]',
                        route: 'md-data-imports-add',
                        auth: { all: [], any: ['DataImportsPermissions@Create'] },
                        visible: false
                    },
                    {
                        name: '[[[Logi importu]]]',
                        route: 'md-data-imports-logs',
                        auth: { all: [], any: ['DataImportsPermissions@View'] },
                        visible: false
                    }
                ]
            },/*
            {
                name: '[[[Nagrody]]]',
                icon: 'far fa-fw fa-solid fa-trophy',
                auth: { all: ['Prizes@View'], any: [] },
                route: 'md-prizes',
                children: [
                ]
            },*/
            {
                name: '[[[Quizy]]]',
                icon: 'far fa-fw fa-solid fa-square-poll-horizontal',
                auth: { all: ['QuizzesPermissions@View'], any: [] },
                route: 'md-quizzes',
                children: [
                    {
                        name: '[[[Dodanie quizu]]]',
                        route: 'md-quizzes-add',
                        auth: { all: [], any: ['QuizzesPermissions@Edit'] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja quizu]]]',
                        route: 'md-quizzes-edit',
                        auth: { all: [], any: ['QuizzesPermissions@View'] },
                        visible: false
                    },
                    {
                        name: '[[[Wyniki]]]',
                        route: 'md-quizzes-results',
                        auth: {all: ['QuizzesPermissions@ViewResults'], any: []},
                        visible: false
                    },
                    {
                        name: '[[[Podejście]]]',
                        route: 'md-quizzes-result',
                        auth: {all: ['QuizzesPermissions@ViewResults'], any: []},
                        visible: false
                    },
                    {
                        name: '[[[Pytania]]]',
                        route: 'md-quizzes-questions',
                        auth: {all: ['QuizzesPermissions@ViewQuestions'], any: []},
                        visible: false
                    },
                    {
                        name: '[[[Dodanie pytania]]]',
                        route: 'md-quizzes-question-add',
                        auth: {all: ['QuizzesPermissions@EditQuestion'], any: []},
                        visible: false
                    },
                    {
                        name: '[[[Edycja pytania]]]',
                        route: 'md-quizzes-questions-edit',
                        auth: {all: ['QuizzesPermissions@EditQuestion'], any: []},
                        visible: false
                    },
                    {
                        name: '[[[Dodanie pytania]]]',
                        route: 'md-quizzes-questions-add',
                        auth: {all: ['QuizzesPermissions@EditQuestion'], any: []},
                        visible: false
                    },
                    {
                        name: '[[[Dodanie teorii]]]',
                        route: 'md-quizzes-theory-add',
                        auth: {all: ['QuizzesPermissions@EditQuestion'], any: []},
                        visible: false
                    },
                    {
                        name: '[[[Edycja teorii]]]',
                        route: 'md-quizzes-theory-edit',
                        auth: {all: ['QuizzesPermissions@EditQuestion'], any: []},
                        visible: false
                    }
                ]
            },
            // {
            //     name: '[[[Szkolenia]]]',
            //     icon: 'far fa-fw fa-solid fa-square-poll-horizontal',
            //     auth: { all: ['CoursesPermissions@View'], any: [] },
            //     route: 'md-courses',
            //     children: [
            //         {
            //             name: '[[[Dodanie szkolenia]]]',
            //             route: 'md-courses-add',
            //             auth: { all: [], any: ['CoursesPermissions@Edit'] },
            //             visible: false
            //         },
            //         {
            //             name: '[[[Konfiguracja]]]',
            //             route: 'md-courses-configuration',
            //             auth: { all: [], any: ['CoursesPermissions@Edit']},
            //             visible: false
            //         },
            //         {
            //             name: '[[[Edycja szkolenia]]]',
            //             route: 'md-courses-edit',
            //             auth: { all: [], any: ['CoursesPermissions@View'] },
            //             visible: false
            //         },
            //         {
            //             name: '[[[Tematy]]]',
            //             route: 'md-course-subjects',
            //             auth: {all: [], any: ['CourseSubjectsPermissions@View']},
            //             visible: false
            //         },
            //         {
            //             name: '[[[Dodaj temat]]]',
            //             route: 'md-course-subjects-add',
            //             auth: {all: [], any: ['CourseSubjectsPermissions@Edit']},
            //             visible: false
            //         },
            //         {
            //             name: '[[[Edycja tematu]]]',
            //             route: 'md-course-subjects-edit',
            //             auth: {all: [], any: ['CourseSubjectsPermissions@Edit']},
            //             visible: false
            //         },
            //         {
            //             name: '[[[Moduły]]]',
            //             route: 'md-course-modules',
            //             auth: {all: [], any: ['CourseModulesPermissions@View']},
            //             visible: false
            //         },
            //         {
            //             name: '[[[Dodaj moduł]]]',
            //             route: 'md-course-modules-add',
            //             auth: {all: [], any: ['CourseModulesPermissions@Edit']},
            //             visible: false
            //         },
            //         {
            //             name: '[[[Edycja modułu]]]',
            //             route: 'md-course-modules-edit',
            //             auth: {all: [], any: ['CourseModulesPermissions@Edit']},
            //             visible: false
            //         },
            //         {
            //             name: '[[[Wyniki]]]',
            //             route: 'md-course-modules-results',
            //             auth: {all: [], any: ['CourseModulesPermissions@View']},
            //             visible: false
            //         }
            //     ]
            // },
            // {
            //     name: '[[[Paczki SCORM]]]',
            //     icon: 'fas fa-fw fa-book-open',
            //     auth: { all: ['ScormPackagesPermissions@View'], any: [] },
            //     children: [
            //         {
            //             name: '[[[Lista paczek SCORM]]]',
            //             route: 'md-scorm-scormpackages',
            //             icon: 'fas fa-fw fa-grip-vertical',
            //             auth: { all: ['ScormPackagesPermissions@View'], any: [] },
            //             children: [
            //                 {
            //                     name: '[[[Dodanie paczki SCORM]]]',
            //                     route: 'md-scorm-scormpackages-add',
            //                     auth: { all: ['ScormPackagesPermissions@Edit'], any: [] },
            //                     visible: false
            //                 },
            //                 {
            //                     name: '[[[Edycja paczek SCORM]]]',
            //                     route: 'md-scorm-scormpackages-edit',
            //                     auth: { all: ['ScormPackagesPermissions@Edit'], any: [] },
            //                     visible: false
            //                 }
            //             ]
            //         }
            //     ]
            // }
        ]
    },
    {
        name: '[[[Katalog nagród]]]',
        short: '[[[Katalog]]]',
        icon: 'fad fa-fw fa-gift',
        namespace: 'Ideo.Core.Edito.Application.Permissions.Catalog',
        children: [
            {
                name: '[[[Konfiguracja kategorii]]]',
                route: 'catalog-categories-configurations',
                icon: 'far fa-fw fa-file-alt',
                auth: {all: ['CategoriesConfigurationPermissions@View'], any: []},
                children: [
                    {
                        name: '[[[Dodanie konfigurację]]]',
                        route: 'catalog-categories-configuration-add',
                        auth: {all: ['CategoriesConfigurationPermissions@Edit'], any: []},
                        visible: false
                    },
                    {
                        name: '[[[Edycja konfiguracji]]]',
                        route: 'catalog-categories-configuration-edit',
                        auth: {all: ['CategoriesConfigurationPermissions@Edit'], any: []},
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Zamówienia]]]',
                route: 'catalog-orders',
                icon: 'fa-solid fa-list',
                auth: {all: ['OrdersPermissions@View'], any: []},
                children: [
                    {
                        name: '[[[Szczegóły]]]',
                        route: 'catalog-orders-edit',
                        auth: {all: ['OrdersPermissions@Edit'], any: []},
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Karty Visa]]]',
                route: 'catalog-prepaid-cards',
                icon: 'fa-solid fa-credit-card',
                auth: {all: ['PrepaidCardsPermissions@View'], any: []},
                children: [
                    {
                        name: '[[[Konfiguracja]]]',
                        route: 'catalog-prepaid-cards-configuration',
                        auth: {all: ['PrepaidCardsPermissions@Config'], any: []},
                        visible: true
                    }
                ]
            },
        ]
    },
    {
        name: '[[[Kampanie]]]',
        short: '[[[Kampanie]]]',
        icon: 'fa-regular fa-envelope',
        namespace: 'Ideo.Core.Edito.Application.Permissions.Md',
        children: [
            {
                name: '[[[Kampanie SMS]]]',
                route: 'md-campaigns-sms',
                auth: {all: ['SmsCampaignsPermissions@View'], any: []},
                visible: true,
                children:[
                    {
                        name: '[[[Dodanie kampanii SMS]]]',
                        route: 'md-campaigns-sms-add',
                        visible: false,
                    },
                    {
                        name: '[[[Edycja kampanii SMS]]]',
                        route: 'md-campaigns-sms-edit',
                        visible: false,
                    },
                ]
            },
            {
                name: '[[[Kampanie Email]]]',
                route: 'md-campaigns-email',
                auth: {all: ['EmailCampaignsPermissions@View'], any: []},
                visible: true,
                children:[
                    {
                        name: '[[[Dodanie kampanii Email]]]',
                        route: 'md-campaigns-email-add',
                        visible: false,
                    },
                    {
                        name: '[[[Edycja kampanii Email]]]',
                        route: 'md-campaigns-email-edit',
                        visible: false,
                    },
                ]
            },
            {
                name: '[[[Kampanie Push]]]',
                route: 'md-campaigns-push',
                auth: {all: ['PushCampaignsPermissions@View'], any: []},
                visible: true,
                children:[
                    {
                        name: '[[[Dodanie kampanii Push]]]',
                        route: 'md-campaigns-push-add',
                        visible: false,
                    },
                    {
                        name: '[[[Edycja kampanii Push]]]',
                        route: 'md-campaigns-push-edit',
                        visible: false,
                    },
                ]
            }
        ]
    },
    {
        name: '[[[CMS]]]',
        short: '[[[CMS]]]',
        icon: 'fa-light fa-globe',
        namespace: 'Ideo.Core.Edito.Application.Permissions.Cms',
        children: [
            {
                name: '[[[Strony]]]',
                route: 'cms-pages',
                icon: 'far fa-fw fa-folder-tree',
                auth: { all: ['PagesPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie strony]]]',
                        route: 'cms-pages-add',
                        auth: { all: ['PagesPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja strony]]]',
                        route: 'cms-pages-edit',
                        auth: { all: ['PagesPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Aranżacje]]]',
                route: 'cms-layouts',
                icon: 'far fa-fw fa-objects-column',
                auth: { all: ['LayoutsPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie aranżacji]]]',
                        route: 'cms-layouts-add',
                        auth: { all: ['LayoutsPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja aranżacji]]]',
                        route: 'cms-layouts-edit',
                        auth: { all: ['LayoutsPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Witryny]]]',
                route: 'cms-websites',
                icon: 'far fa-fw fa-browsers',
                auth: { all: ['WebsitesPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie witryny]]]',
                        route: 'cms-websites-add',
                        auth: { all: ['WebsitesPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja witryny]]]',
                        route: 'cms-websites-edit',
                        auth: { all: ['WebsitesPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Szablony]]]',
                route: 'cms-themes',
                icon: 'far fa-fw fa-sidebar',
                auth: { all: ['ThemesPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie szablonu]]]',
                        route: 'cms-themes-add',
                        auth: { all: ['ThemesPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja szablonu]]]',
                        route: 'cms-themes-edit',
                        auth: { all: ['ThemesPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            }
        ]
    },
    {
        name: '[[[Moduły]]]',
        short: '[[[Moduły]]]',
        route: 'studio-docs',
        preventCloseMenu: true,
        icon: 'fa-light fa-layer-group',
        namespace: 'Ideo.Core.Edito.Application.Permissions.Modules',
        auth: { all: [], any: [] },
        children: [
            {
                name: '[[[Artykuły]]]',
                icon: 'far fa-fw fa-newspaper',
                children: [
                    {
                        name: '[[[Lista artykułów]]]',
                        route: 'cms-articles',
                        auth: { all: ['ArticlesPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie artykułu]]]',
                                route: 'cms-articles-add',
                                auth: { all: [], any: ['ArticlesPermissions@Edit', 'ArticlesPermissions@EditAll'] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja artykułu]]]',
                                route: 'cms-articles-edit',
                                auth: { all: [], any: ['ArticlesPermissions@Edit', 'ArticlesPermissions@EditAll'] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Kategorie]]]',
                        route: 'cms-articles-categories',
                        icon: 'far fa-fw fa-file-alt',
                        auth: { all: ['ArticlesCategoriesPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie kategorii]]]',
                                route: 'cms-articles-categories-add',
                                auth: { all: ['ArticlesCategoriesPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja kategorii]]]',
                                route: 'cms-articles-categories-edit',
                                auth: { all: ['ArticlesCategoriesPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Sortowanie kategorii]]]',
                                route: 'cms-articles-categories-sort',
                                auth: { all: ['ArticlesCategoriesPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Etykiety]]]',
                        route: 'cms-articles-labels',
                        icon: 'far fa-fw fa-file-alt',
                        auth: { all: ['ArticleLabelsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie etykiety]]]',
                                route: 'cms-articles-labels-add',
                                auth: { all: ['ArticleLabelsPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja etykiety]]]',
                                route: 'cms-articles-labels-edit',
                                auth: { all: ['ArticleLabelsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Czołówka]]]',
                        route: 'cms-articles-headline-covers',
                        icon: 'far fa-fw fa-file-alt',
                        auth: { all: ['ArticlesHeadlineCoversPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie czołówki]]]',
                                route: 'cms-articles-headline-covers-add',
                                auth: { all: ['ArticlesHeadlineCoversPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja czołówki]]]',
                                route: 'cms-articles-headline-covers-edit',
                                auth: { all: ['ArticlesHeadlineCoversPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    }
                ]

            },
            {
                name: '[[[Autorzy]]]',
                route: 'cms-authors',
                icon: 'far fa-fw fa-user-vneck-hair',
                auth: { all: ['AuthorsPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Sortowanie autorów]]]',
                        route: 'cms-authors-sort',
                        auth: { all: ['AuthorsPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Dodanie autora]]]',
                        route: 'cms-authors-add',
                        auth: { all: ['AuthorsPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja autora]]]',
                        route: 'cms-authors-edit',
                        auth: { all: ['AuthorsPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Ustawienia redakcji]]]',
                        route: 'cms-authors-editor',
                        auth: { all: ['AuthorsPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Aktualności]]]',
                route: 'cms-informations',
                icon: 'far fa-fw fa-radio-tuner',
                auth: { all: ['InformationsPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie aktualności]]]',
                        route: 'cms-informations-add',
                        auth: { all: [], any: ['InformationsPermissions@Edit', 'InformationsPermissions@EditAll'] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja aktualności]]]',
                        route: 'cms-informations-edit',
                        auth: { all: [], any: ['InformationsPermissions@Edit', 'InformationsPermissions@EditAll'] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Pytania i odpowiedzi]]]',
                route: 'cms-faq',
                icon: 'far fa-fw fa-clipboard-question',
                auth: { all: ['FaqPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie poradnika]]]',
                        route: 'cms-faq-add',
                        auth: { all: [], any: ['FaqPermissions@Edit', 'FaqPermissions@EditAll'] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja poradnika]]]',
                        route: 'cms-faq-edit',
                        auth: { all: [], any: ['FaqPermissions@Edit', 'FaqPermissions@EditAll'] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Ankiety]]]',
                route: 'cms-surveys',
                icon: 'far fa-fw fa-ballot-check',
                auth: { all: ['SurveysPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie ankiety]]]',
                        route: 'cms-surveys-add',
                        auth: { all: [], any: ['SurveysPermissions@Edit', 'SurveysPermissions@EditAll'] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja ankiety]]]',
                        route: 'cms-surveys-edit',
                        auth: { all: [], any: ['SurveysPermissions@Edit', 'SurveysPermissions@EditAll'] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Tagi]]]',
                route: 'cms-tags',
                icon: 'far fa-fw fa-tags',
                auth: { all: ['TagsPermissions@View'], any: [] }
            },
            {
                name: '[[[Katalog linków]]]',
                icon: 'far fa-fw fa-link',
                children: [
                    {
                        name: '[[[Lista linków]]]',
                        route: 'cms-link-links',
                        auth: { all: ['LinksPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie linku]]]',
                                route: 'cms-link-links-add',
                                auth: { all: [], any: ['LinksPermissions@Edit', 'LinksPermissions@EditAll'] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja linku]]]',
                                route: 'cms-link-links-edit',
                                auth: { all: [], any: ['LinksPermissions@Edit', 'LinksPermissions@EditAll'] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Kategorie linków]]]',
                        route: 'cms-link-categories',
                        auth: { all: ['LinkCategoriesPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie kategorii]]]',
                                route: 'cms-link-categories-add',
                                auth: { all: ['LinkCategoriesPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja kategorii]]]',
                                route: 'cms-link-categories-edit',
                                auth: { all: ['LinkCategoriesPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]

                    }
                ]
            },
            {
                name: '[[[RSS]]]',
                route: 'cms-rss',
                icon: 'far fa-fw fa-square-rss',
                auth: { all: ['RssPermissions@View'], any: [] }
            },
            {
                name: '[[[Baza dokumentów]]]',
                icon: 'far fa-fw fa-files',
                children: [
                    {
                        name: '[[[Dokumenty]]]',
                        route: 'cms-documents',
                        auth: { all: ['DocumentsPermission@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie dokumentu]]]',
                                route: 'cms-documents-add',
                                auth: { all: [], any: ['DocumentsPermission@Edit', 'DocumentsPermission@EditAll'] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja dokumentu]]]',
                                route: 'cms-documents-edit',
                                auth: { all: [], any: ['DocumentsPermission@Edit', 'DocumentsPermission@EditAll'] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Kategorie]]]',
                        route: 'cms-documents-categories',
                        auth: { all: ['DocumentsCategoriesPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie kategorii]]]',
                                route: 'cms-documents-categories-add',
                                auth: { all: ['DocumentsCategoriesPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja kategorii]]]',
                                route: 'cms-documents-categories-edit',
                                auth: { all: ['DocumentsCategoriesPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    }
                ]
            },
            {
                name: '[[[Galeria zdjęć]]]',
                route: 'cms-gallery',
                icon: 'far fa-fw fa-image',
                auth: { all: ['PhotoGalleryPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie galerii]]]',
                        route: 'cms-gallery-add',
                        auth: { all: [], any: ['PhotoGalleryPermissions@Edit', 'PhotoGalleryPermissions@EditAll'] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja galerii]]]',
                        route: 'cms-gallery-edit',
                        auth: { all: [], any: ['PhotoGalleryPermissions@Edit', 'PhotoGalleryPermissions@EditAll'] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Wideo]]]',
                route: 'cms-videos',
                icon: 'far fa-fw fa-video',
                auth: { all: ['VideosPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie wideo]]]',
                        route: 'cms-videos-add',
                        auth: { all: [], any: ['VideosPermissions@Edit', 'VideosPermissions@EditAll'] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja wideo]]]',
                        route: 'cms-videos-edit',
                        auth: { all: [], any: ['VideosPermissions@Edit', 'VideosPermissions@EditAll'] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Rotatory opinii]]]',
                route: 'cms-opinion-sliders',
                auth: { all: ['OpinionSlidersPermissions@View'], any: [] },
                icon: 'fa-sharp fa-regular fa-comments',
                children: [
                    {
                        name: '[[[Dodanie rotatora]]]',
                        route: 'cms-opinion-sliders-add',
                        auth: { all: ['OpinionSlidersPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja rotatora]]]',
                        route: 'cms-opinion-sliders-edit',
                        auth: { all: ['OpinionSlidersPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Przekierowania]]]',
                route: 'cms-redirections',
                icon: "fa-regular fa-right-left-large",
                auth: { all: ['RedirectionsPermissions@View'], any: [] },
            },
            {
                name: '[[[Gazetka]]]',
                icon: 'far fa-fw fa-book-open',
                route: 'cms-flipping-book',
                auth: { all: ['FlippingbooksPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie gazetki]]]',
                        route: 'cms-flipping-book-add',
                        auth: { all: ['FlippingbooksPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja gazetki]]]',
                        route: 'cms-flipping-book-edit',
                        auth: { all: ['FlippingbooksPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
        ]
    },
    {
        name: '[[[Marketing]]]',
        short: '[[[Marketing]]]',
        icon: 'fa-light fa-chart-pie',
        namespace: 'Ideo.Core.Edito.Application.Permissions.Marketing',
        children: [
            {
                name: '[[[Subskrypcje]]]',
                icon: 'fa-regular fa-envelope',
                auth: { all: ['SubscriptionsPermissions@View'], any: [] },
                route: 'cms-subscriptions'
            },
            {
                name: '[[[Zgody]]]',
                icon: 'far fa-fw fa-file-contract',
                auth: { all: [], any: ['RegulationsSetsPermissions@View', 'RegulationsPermissions@View'] },
                children: [
                    {
                        name: '[[[Lista zgód]]]',
                        route: 'cms-regulations',
                        auth: { all: ['RegulationsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie zgody]]]',
                                route: 'cms-regulations-add',
                                auth: { all: [], any: ['RegulationsPermissions@Edit', 'RegulationsPermissions@EditAll'] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja zgody]]]',
                                route: 'cms-regulations-edit',
                                auth: { all: [], any: ['RegulationsPermissions@Edit', 'RegulationsPermissions@EditAll'] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Ustawienia]]]',
                        route: 'cms-regulations-sets',
                        auth: { all: ['RegulationsSetsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie zestawu regulaminów]]]',
                                route: 'cms-regulations-sets-add',
                                auth: { all: ['RegulationsSetsPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja zestawu regulaminów]]]',
                                route: 'cms-regulations-sets-edit',
                                auth: { all: ['RegulationsSetsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    }
                ]
            },
            {
                name: '[[[Komentarze]]]',
                icon: 'far fa-fw fa-messages',
                auth: { all: ['CommentsPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Lista komentarzy]]]',
                        route: 'cms-comments',
                        auth: { all: ['CommentsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Edycja komentarza]]]',
                                route: 'cms-comments-edit',
                                auth: { all: ['CommentsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Ustawienia]]]',
                        route: 'cms-comments-sets',
                        auth: { all: ['CommentsSetsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Edycja ustawień]]]',
                                route: 'cms-comments-sets-edit',
                                auth: { all: ['CommentsSetsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    }
                ]
            },
            {
                name: '[[[Top tematy]]]',
                route: 'cms-top-topics',
                icon: 'far fa-fw fa-window-restore',
                auth: { all: ['TopTopicsPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie top tematu]]]',
                        route: 'cms-top-topics-add',
                        auth: { all: ['TopTopicsPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja top tematu]]]',
                        route: 'cms-top-topics-edit',
                        auth: { all: ['TopTopicsPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Linki wewnętrzne]]]',
                route: 'cms-internal-links',
                icon: 'far fa-fw fa-link',
                auth: { all: ['InternalLinksPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie linku wewnętrznego]]]',
                        route: 'cms-internal-links-add',
                        auth: { all: ['InternalLinksPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja linku wewnętrznego]]]',
                        route: 'cms-internal-links-edit',
                        auth: { all: ['InternalLinksPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Banery]]]',
                icon: 'far fa-fw fa-billboard',
                children: [
                    {
                        name: '[[[Lista banerów]]]',
                        route: 'cms-banners',
                        auth: { all: ['BannersPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie baneru]]]',
                                route: 'cms-banners-add',
                                auth: { all: ['BannersPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja baneru]]]',
                                route: 'cms-banners-edit',
                                auth: { all: ['BannersPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Grupy]]]',
                        route: 'cms-banner-groups',
                        auth: { all: ['BannerGroupsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie grupy]]]',
                                route: 'cms-banner-groups-add',
                                auth: { all: ['BannerGroupsPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja grupy]]]',
                                route: 'cms-banner-groups-edit',
                                auth: { all: ['BannerGroupsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    }
                ]

            },
            {
                name: '[[[Slajdery]]]',
                route: 'cms-sliders',
                icon: 'far fa-fw fa-columns-3',
                auth: { all: ['SlidersPermissions@View'], any: [] },
                children: [
                    {
                        name: '[[[Dodanie slajdera]]]',
                        route: 'cms-sliders-add',
                        auth: { all: ['SlidersPermissions@Edit'], any: [] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja slajdera]]]',
                        route: 'cms-sliders-edit',
                        auth: { all: ['SlidersPermissions@Edit'], any: [] },
                        visible: false
                    }
                ]
            }
        ]
    },
    {
        name: '[[[Sklep]]]',
        short: '[[[Sklep]]]',
        icon: 'fa-light fa-cart-shopping',
        children: [
            {
                name: '[[[Katalog]]]',
                icon: 'fa-regular fa-swatchbook',
                children: [
                    {
                        name: '[[[Produkty]]]',
                        route: 'store-products',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Products.Permissions',
                        auth: { all: ['ProductsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie produktu]]]',
                                route: 'store-products-add',
                                auth: { all: ['ProductsPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja produktu]]]',
                                route: 'store-products-edit',
                                auth: { all: ['ProductsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Etykiety produktów]]]',
                        route: 'store-labels',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Labels.Permissions',
                        auth: { all: ['LabelsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie etykiety]]]',
                                route: 'store-labels-add',
                                auth: { all: ['LabelsPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja etykiety]]]',
                                route: 'store-labels-edit',
                                auth: { all: ['LabelsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Cechy]]]',
                        route: 'store-properties',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Properties.Permissions',
                        auth: { all: ['PropertiesPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie cechy]]]',
                                route: 'store-properties-add',
                                auth: { all: ['PropertiesPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja cechy]]]',
                                route: 'store-properties-edit',
                                auth: { all: ['PropertiesPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Sortowanie cech]]]',
                                route: 'store-properties-sort',
                                auth: { all: ['PropertiesPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Sortowanie wartości]]]',
                                route: 'store-properties-values-sort',
                                auth: { all: ['PropertiesPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Grupy cech]]]',
                        route: 'store-properties-groups',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.PropertiesGroups.Permissions',
                        auth: { all: ['PropertiesGroupsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie grupy cech]]]',
                                route: 'store-properties-groups-add',
                                auth: { all: ['PropertiesGroupsPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja grupy cech]]]',
                                route: 'store-properties-groups-edit',
                                auth: { all: ['PropertiesGroupsPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Sortowanie grup cech]]]',
                                route: 'store-properties-groups-sort',
                                auth: { all: ['PropertiesGroupsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Producenci]]]',
                        route: 'store-producers',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Producers.Permissions',
                        icon: 'fa-user-tie-hair',
                        auth: { all: ['ProducersPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie producenta]]]',
                                route: 'store-producers-add',
                                auth: { all: ['ProducersPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja producenta]]]',
                                route: 'store-producers-edit',
                                auth: { all: ['ProducersPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Kategorie]]]',
                        route: 'store-categories',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Categories.Permissions',
                        icon: 'far fa-fw fa-folder-tree',
                        auth: { all: ['CategoriesPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie kategorii]]]',
                                route: 'store-categories-add',
                                auth: { all: ['CategoriesPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja kategorii]]]',
                                route: 'store-categories-edit',
                                auth: { all: ['CategoriesPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Kolekcje]]]',
                        route: 'store-collections',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Collections.Permissions',
                        icon: 'far fa-fw fa-rectangle-history',
                        auth: { all: ['CollectionsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie kolekcji]]]',
                                route: 'store-collections-add',
                                auth: { all: ['CollectionsPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja kolekcji]]]',
                                route: 'store-collections-edit',
                                auth: { all: ['CollectionsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                ]
            },
            {
                name: '[[[Sklepy]]]',
                icon: 'far fa-fw fa-radio-tuner',
                children: [
                    {
                        name: '[[[Lista sklepów]]]',
                        route: 'store-shops',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Shops.Permissions',
                        auth: { all: ['ShopsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie sklepów]]]',
                                route: 'store-shops-add',
                                auth: { all: ['ShopsPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja sklepów]]]',
                                route: 'store-shops-edit',
                                auth: { all: ['ShopsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Cenniki]]]',
                        route: 'store-price-lists',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.PriceLists.Permissions',
                        auth: { all: ['PriceListsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie cennika]]]',
                                route: 'store-price-lists-add',
                                auth: { all: ['PriceListsPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja cennika]]]',
                                route: 'store-price-lists-edit',
                                auth: { all: ['PriceListsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                ]
            },
            {
                name: '[[[Konfiguracja]]]',
                icon: 'far fa-fw fa-cog',
                children: [
                    {
                        name: '[[[Waluty]]]',
                        route: 'store-currencies',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Currencies.Permissions',
                        auth: { all: ['CurrenciesPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie waluty]]]',
                                route: 'store-currencies-add',
                                auth: { all: ['CurrenciesPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja waluty]]]',
                                route: 'store-currencies-edit',
                                auth: { all: ['CurrenciesPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Podatki]]]',
                        route: 'store-taxations',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Taxations.Permissions',
                        auth: { all: ['CurrenciesPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie stawki]]]',
                                route: 'store-taxations-add',
                                auth: { all: ['TaxationsPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja stawki]]]',
                                route: 'store-taxations-edit',
                                auth: { all: ['TaxationsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Kraje]]]',
                        route: 'store-countries',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Countries.Permissions',
                        auth: { all: ['CountriesPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie kraju]]]',
                                route: 'store-countries-add',
                                auth: { all: ['CountriesPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja kraju]]]',
                                route: 'store-countries-edit',
                                auth: { all: ['CountriesPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Dostawy]]]',
                        route: 'store-carriers',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Carriers.Permissions',
                        auth: { all: ['CarriersPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie opcji dostawy]]]',
                                route: 'store-carriers-add',
                                auth: { all: ['CarriersPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja opcji dostawy]]]',
                                route: 'store-carriers-edit',
                                auth: { all: ['CarriersPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Płatności]]]',
                        route: 'store-payments',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Payments.Permissions',
                        auth: { all: ['PaymentsPermissions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie opcji płatności]]]',
                                route: 'store-payments-add',
                                auth: { all: ['PaymentsPermissions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja opcji płatności]]]',
                                route: 'store-payments-edit',
                                auth: { all: ['PaymentsPermissions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    },
                    {
                        name: '[[[Kalendarz]]]',
                        route: 'store-calendar-entries',
                        namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.CalendarEntries.Permissions',
                        auth: { all: ['CalendarEntriesPermisions@View'], any: [] },
                        children: [
                            {
                                name: '[[[Dodanie wpisu do kalendarza]]]',
                                route: 'store-calendar-entries-add',
                                auth: { all: ['CalendarEntriesPermisions@Edit'], any: [] },
                                visible: false
                            },
                            {
                                name: '[[[Edycja wpisu do kalendarza]]]',
                                route: 'store-calendar-entries-edit',
                                auth: { all: ['CalendarEntriesPermisions@Edit'], any: [] },
                                visible: false
                            }
                        ]
                    }
                ]
            },
        ]
    },
    {
        name: '[[[Premium]]]',
        short: '[[[Premium]]]',
        icon: 'fa-light fa-file-invoice-dollar',
        namespace: 'Ideo.Core.Edito.Application.Permissions.Premium',
        children: [
            {
                name: '[[[Pakiety]]]',
                icon: 'fa-regular fa-cubes',
                auth: { all: ['PackagesPermissions@View'], any: [] },
                route: 'premium-packages',
                children: [
                    {
                        name: '[[[Dodanie pakietu]]]',
                        route: 'premium-packages-add',
                        auth: { all: [], any: ['PackagesPermissions@Edit'] },
                        visible: false
                    },
                    {
                        name: '[[[Edycja pakietu]]]',
                        route: 'premium-packages-edit',
                        auth: { all: [], any: ['PackagesPermissions@Edit'] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Konfiguracja]]]',
                icon: 'far fa-fw fa-sliders',
                auth: { all: [], any: ['SettingsPermissions@View'] },
                children: [
                    {
                        name: '[[[Ustawienia płatności]]]',
                        route: 'premium-settings',
                        auth: { all: ['SettingsPermissions@View'], any: [] }
                    },
                    {
                        name: '[[[Zamówienia]]]',
                        route: 'premium-settings-orders',
                        auth: { all: ['SettingsPermissions@View'], any: [] }
                    },
                    {
                        name: '[[[Powiadomienia]]]',
                        route: 'premium-settings-notifications',
                        auth: { all: ['SettingsPermissions@View'], any: [] }
                    }
                ]
            },
            {
                name: '[[[Zamówienia]]]',
                icon: 'fa-regular fa-receipt',
                auth: { all: ['OrdersPremissions@View'], any: [] },
                route: 'premium-orders',
                children: [
                    {
                        name: '[[[Szczegóły zamówienia]]]',
                        route: 'premium-orders-view',
                        auth: { all: [], any: ['OrdersPremissions@View'] },
                        visible: false
                    }
                ]
            },
            {
                name: '[[[Klienci]]]',
                icon: 'fa-regular fa-user-group-simple',
                auth: { all: ['CustomersPermissions@View'], any: [] },
                route: 'premium-customers',
                children: [
                    {
                        name: '[[[Szczegóły klienta]]]',
                        route: 'premium-customers-view',
                        auth: { all: [], any: ['CustomersPermissions@View'] },
                        visible: false
                    }
                ]
            }
        ]
    },
    {
        name: '[[[Repozytorium plików]]]',
        short: '[[[Pliki]]]',
        route: 'filemanager',
        preventCloseMenu: true,
        icon: 'fa-light fa-folder-closed',
        namespace: 'Ideo.Core.Common.Application.Permissions.Storage',
        auth: { all: ['StoragePermissions@Access'], any: [] }
    },
    {
        name: '[[[Kosz]]]',
        short: '[[[Kosz]]]',
        route: 'trash',
        preventCloseMenu: true,
        icon: 'fa-light fa-trash',
        namespace: 'Ideo.Core.Common.Application.Permissions.Core',
        auth: { all: ['TrashPermissions@View'], any: [] },
        children: [
            {
                name: '[[[Grupa]]]',
                route: 'trash-group',
                visible: false
            }
        ]
    }
];
